import { render, staticRenderFns } from "./Internet-data.vue?vue&type=template&id=3e90d0d2"
import script from "./Internet-data.vue?vue&type=script&lang=js"
export * from "./Internet-data.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports